// extracted by mini-css-extract-plugin
export var alertIcon = "_q3-0";